/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  // {
  //   path: '/cartoes',
  //   name: 'Cartões',
  //   view: 'Cards',
  //   meta: {
  //     requiresAuth: true,
  //     //requiresGroup: ['admin','partner']
  //   }
  // },
  {
    path: "/dashboard",
    // Relative to /src/views
    view: "Dashboard",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial", "partner", "partner_management"],
    },
  },
  {
    path: "/user-profile",
    name: "Minha Conta",
    view: "UserProfile",
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/table-list',
  //   name: 'Table List',
  //   view: 'TableList',
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  {
    path: "/leads",
    name: "Leads",
    view: "LeadList",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "marketing"],
    },
  },
  {
    path: "/unidades-consumidoras",
    name: "Unidades Consumidoras",
    view: "ConsumerUnitList-pagination",
    // view: 'ConsumerUnits',
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "customer_care", "sales"],
    },
  },
  {
    path: "/unidades-consumidoras2",
    name: "UnidadesConsumidoras",
    view: "ConsumerUnitList",
    // view: 'ConsumerUnits',
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "customer_care", "sales"],
    },
  },
  {
    path: "/membros",
    name: "Membros",
    view: "CustomerList",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "customer_care", "sales", "eletron"],
    },
  },
  {
    path: "/membro",
    name: "Cliente",
    view: "Customer",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "customer_care", "eletron"],
    },
  },
  {
    path: "/membro/:id",
    name: "Detalhe do Cliente",
    view: "Customer",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "customer_care", "eletron"],
    },
  },
  // {
  //   path: '/unidades-consumidoras/faturas/:id',
  //   name: 'FaturaCliente',
  //   view: 'Invoice',
  //   meta: {
  //     requiresAuth: true,
  //     requiresGroup: ['admin', 'financial', 'customer_care']
  //   }
  // },
  // {
  //   path: '/faturas',
  //   name: 'Faturas',
  //   view: 'Fatura',
  //   meta: {
  //     requiresAuth: true,
  //     //requiresGroup: ['admin','partner']
  //   }
  // },
  {
    path: "/login",
    name: "login",
    view: "Login",
    meta: {
      fullpage: true,
      public: true,
    },
  },
  {
    path: "/esqueci-senha",
    name: "esquecisenha",
    view: "EsqueciSenha",
    meta: {
      fullpage: true,
      public: true,
    },
  },
  {
    path: "/reinicia-senha",
    name: "reiniciasenha",
    view: "ReiniciaSenha",
    meta: {
      fullpage: true,
      public: true,
    },
  },
  {
    path: "/lead",
    name: "Lead",
    view: "Lead",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "marketing"],
    },
  },
  {
    path: "/lead/:id",
    name: "Detalhe do Lead",
    view: "Lead",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "marketing"],
    },
  },
  {
    path: "/faturar",
    name: "Faturar",
    view: "backoffice/Faturar",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/faturar/detail",
    name: "Detalhes das Faturas",
    view: "backoffice/FaturaDetail",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/transaction/:id",
    name: "Detalhe da Transação",
    view: "Transaction",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/indicacoes",
    name: "Indicações",
    view: "backoffice/Referral",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin"],
    },
  },
  {
    path: "/extrato_old",
    name: "Extrato_old",
    view: "Extrato",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "partner", "financial", "partner_management"],
    },
  },
  {
    path: "/extrato",
    name: "Extrato",
    view: "ExtratoPagarme",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "partner", "financial", "partner_management"],
    },
  },
  {
    path: "/sales/",
    name: "Sales",
    view: "Sales",
    meta: {
      requiresAuth: true,
      requiresGroup: [
        "admin",
        "sales",
        "sales_partner",
        "sales_management",
        "sales_partner_management",
      ],
    },
  },
  {
    path: "/vendas/",
    name: "Vendas",
    view: "sales/Kanban",
    meta: {
      requiresAuth: true,
      requiresGroup: [
        "admin",
        "sales",
        "sales_partner",
        "sales_management",
        "sales_partner_management",
        "quality_management",
      ],
    },
  },
  {
    path: "/vendas/dashboard",
    name: "Dashboard de Vendas",
    view: "Sales",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "sales", "sales_partner", "sales_management"],
    },
  },
  {
    path: "/lista_vendas",
    name: "Lista de Vendas",
    view: "sales/Sales",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "sales", "sales_partner", "sales_management"],
    },
  },
  {
    path: "/prospects",
    name: "Lista de Prospects",
    view: "sales/SavedSales",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "sales", "sales_partner", "sales_management"],
    },
  },
  {
    path: "/listas/",
    name: "Listas",
    view: "ExportList",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/atendimento/",
    name: "Atendimento",
    view: "cs/Support",
    meta: {
      requiresAuth: true,
      requiresGroup: [
        "admin",
        "customer_care",
        "financial",
        "collection",
        "eletron",
        "external_collection",
      ],
    },
  },
  {
    path: "/atendimento/:id",
    name: "AtendimentoId",
    view: "cs/Support",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "customer_care", "financial", "eletron"],
    },
  },
  {
    path: "/atendimento/tarefas",
    name: "Tarefas",
    view: "cs/Tasks",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "customer_care", "financial"],
    },
  },
  {
    path: "/atendimento/ticket",
    name: "Ticket",
    view: "cs/Ticket",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "customer_care", "financial"],
    },
  },
  {
    path: "/atendimento/dashboard",
    name: "Dashboard Atendimento",
    view: "cs/Dashboard",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "customer_care"],
    },
  },
  {
    path: "/faturamento/",
    name: "Faturamento",
    view: "billing/Home",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/faturamento/saque",
    name: "Saque",
    view: "operations/Withdrawals",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/faturamento/tarifas",
    name: "Lista de Tarifas",
    view: "billing/FaresList",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial", "partner_management"],
    },
  },
  {
    path: "/faturamento/lista",
    name: "Lista de Faturamento",
    view: "billing/BillingList",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial", "partner_management"],
    },
  },
  {
    path: "/faturamento/nao-faturadas",
    name: "Lista das Não Faturadas",
    view: "billing/NotBilledList",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial", "partner_management"],
    },
  },
  {
    path: "/faturamento/xml",
    name: "Dados em XML",
    view: "billing/xmlList/xmlList",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial", "partner_management"],
    },
  },
  {
    path: "/faturamento/planilhas",
    name: "Upload de Planilhas",
    view: "billing/SheetsUpload",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial", "partner_management"],
    },
  },
  {
    path: "/faturamento/juncao-faturas",
    name: "Junção de Faturas",
    view: "billing/mergingInvoicesList",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  // {
  //   path: '/conta-unica/lista',
  //   name: 'Lista de Faturamento Conta Única',
  //   view: 'billing/UniqueBillingList',
  //   meta: {
  //     requiresAuth: true,
  //     requiresGroup: ['admin', 'financial']
  //   }
  // },
  {
    path: "/home",
    name: "Home",
    view: "ToMobile",
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/disparos",
    name: "Disparos",
    view: "BulkMailing",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "customer_care"],
    },
  },
  {
    path: "/membros/faturas/:id",
    name: "Faturas",
    view: "members/Billings",
    meta: {
      fullpage: true,
      public: true,
    },
  },
  {
    path: "/membros/negociar/:id",
    name: "Negociacao",
    view: "members/Negotiated",
    meta: {
      fullpage: true,
      public: true,
    },
  },
  {
    path: "/membros/negociacao-concluida",
    name: "NegociacaoConcluida",
    view: "members/NegotiatedDone",
    meta: {
      fullpage: true,
      public: true,
    },
  },
  {
    path: "/marketing/cupons",
    name: "Cupons",
    view: "marketing/CouponList",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "marketing"],
    },
  },
  // {
  //   path: '/qualificacao',
  //   name: 'Qualificação',
  //   view: 'QualificationList',
  //   meta: {
  //     requiresAuth: true,
  //     requiresGroup: ['admin', 'customer_care', 'sales', 'sales_management']
  //   }
  // },
  {
    path: "/concessionaria/arquivos",
    name: "Concessionaria",
    view: "utilityFiles/UtilityFiles",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/configuracao/usuarios",
    name: "Configuração dos Usuarios do Super",
    view: "configuration/Users",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "access_grantor"],
    },
  },
  {
    path: "/configuracao/parceiros",
    name: "Configuração dos Parceiros",
    view: "configuration/Partners",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial", "access_grantor"],
    },
  },
  {
    path: "/configuracao/usinas",
    name: "Configuração das Usinas",
    view: "configuration/PowerPlants",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/configuracao/planos",
    name: "Configuração dos Planos",
    view: "configuration/Plans",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/configuracao/tabulacao",
    name: "Configuração das Tabulações",
    view: "configuration/Tabulations",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin"],
    },
  },
  {
    path: "/configuracao/concessionarias",
    name: "Configuração das Concessionárias",
    view: "configuration/UtilityCompanies",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/configuracao/cooperativas",
    name: "Configuração das Cooperativas",
    view: "configuration/Cooperatives",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/conta-unica/lotes",
    name: "Lista de Lotes de Unificadas",
    view: "uniqueBilling/BankBatchs",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial", "customer_care", "collection"],
    },
  },
  {
    path: "/conta-unica/lotes-usinas",
    name: "Lista de Lotes de Usinas",
    view: "uniqueBilling/BankBatchsUsinas",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "financial"],
    },
  },
  {
    path: "/simulador",
    name: "simulator",
    view: "simulator/Simulator",
    meta: {
      fullpage: false,
      public: true,
      requiresAuth: true,
    },
  },
  {
    path: "/configuracao/encurtador",
    name: "Encurtador de Url",
    view: "configuration/UrlShortner",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "sales_management", "marketing"],
    },
  },
  {
    path: "/configuracao/feriados",
    name: "Configuração dos Feriados",
    view: "configuration/Holidays",
    meta: {
      requiresAuth: true,
      requiresGroup: ["admin", "marketing"],
    },
  },
  {
    path: "/integracao/correios/:id",
    name: "Integração Correios",
    view: "integration/Correios",
    meta: {
      fullpage: true,
      public: true,
    },
  },
];
